import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
	selector: 'lb-two-column-page-layout',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './two-column-page-layout.component.html',
	styleUrl: './two-column-page-layout.component.scss'
})
export class TwoColumnPageLayoutComponent {
	stickyLeft = input(false);
}
